// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-all-js": () => import("./../../../src/pages/all.js" /* webpackChunkName: "component---src-pages-all-js" */),
  "component---src-pages-change-request-js": () => import("./../../../src/pages/change-request.js" /* webpackChunkName: "component---src-pages-change-request-js" */),
  "component---src-pages-disciplines-js": () => import("./../../../src/pages/disciplines.js" /* webpackChunkName: "component---src-pages-disciplines-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-teams-by-discipline-js": () => import("./../../../src/pages/teams-by-discipline.js" /* webpackChunkName: "component---src-pages-teams-by-discipline-js" */)
}

